/* eslint-disable @typescript-eslint/naming-convention */
export class Coupon {
  constructor(
    public coupon_code?: string,
    public profile_ids?: Array<number>,
    public newspapers?: Array<any>,
    public applyedProfile?: Array<any>,
    public duration?: number
  ) {}
}
